/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCaretDown = createReactComponent("outline", "caret-down", "IconCaretDown", [["path", { "d": "M6 10l6 6l6 -6h-12", "key": "svg-0" }]]);

export { IconCaretDown as default };
//# sourceMappingURL=IconCaretDown.mjs.map
